/* Bisou Rivage — les pop-ups (snippets/bisou-popups.liquid, fiche site-popups-v7).
   Une seule carte par visite, jamais sur la premiere page de la visite, jamais
   par-dessus un tiroir, un champ en cours de saisie ou la banniere des cookies.
   Une carte fermee ne revient pas avant 14 jours.
   R18e (algorithme 2c, 25/10) : une seule memoire pour « ferme » et « deja vu ».
   - br_fenetres (local) : { nom: date de fermeture } ; 14 jours pour chacune.
   - br_fenetre_visite (session) : une fenetre s'est deja montree dans la visite,
     quelle qu'elle soit (ces cartes, la pastille de langue de bisou-alt.js § 25,
     la carte newsletter de bisou-ventes-fidelite.js) : plus rien d'autre.
   - Inscrit par n'importe quel formulaire (pied de page, vote, carte) : la carte
     newsletter ne revient plus jamais (bvf_nl_done, la cle qu'elle lit deja). */
(function () {
  'use strict';

  var racine = document.querySelector('[data-bisou-popups]');
  if (!racine) return;

  var QUATORZE_JOURS = 14 * 24 * 3600 * 1000;
  var CLE_VUE = 'bp_vue';          /* session : une carte deja montree */
  var CLE_PAGES = 'bp_pages';      /* session : pages vues dans la visite */
  var CLE_OFF = 'bp_off';          /* session : ?popups=off */
  var CLE_FERMEE = 'bp_fermee_';   /* local : + nom de la carte (ancienne memoire, encore lue) */
  var CLE_FENETRES = 'br_fenetres';         /* local : { nom: date de fermeture }, la memoire commune */
  var CLE_VISITE = 'br_fenetre_visite';     /* session : une fenetre deja montree dans la visite */

  function lire(stock, cle) { try { return stock.getItem(cle); } catch (e) { return null; } }
  function ecrire(stock, cle, v) { try { stock.setItem(cle, v); } catch (e) {} }

  var demande = null;
  try { demande = new URLSearchParams(location.search).get('popups'); } catch (e) {}
  if (demande === 'off') ecrire(sessionStorage, CLE_OFF, '1');
  if (demande === 'on') { try { sessionStorage.removeItem(CLE_OFF); sessionStorage.removeItem(CLE_VUE); sessionStorage.removeItem(CLE_VISITE); } catch (e) {} }

  /* Inscrit, quel que soit le formulaire : Shopify revient avec ?customer_posted=true. */
  try { if (/[?&]customer_posted=true/.test(location.search)) ecrire(localStorage, 'bvf_nl_done', '1'); } catch (e) {}

  /* La pastille de langue et la carte newsletter comptent aussi : des qu'elles se
     montrent, la visite a eu sa fenetre. Elles se posent a la racine du <body>. */
  function autreFenetre() {
    var nl = document.getElementById('bvf-nl');
    return !!(document.querySelector('.bvf-lang') || (nl && nl.classList.contains('is-open')));
  }
  if (window.MutationObserver && document.body) {
    var guet = new MutationObserver(function () {
      if (autreFenetre() && !lire(sessionStorage, CLE_VISITE)) ecrire(sessionStorage, CLE_VISITE, 'autre');
    });
    guet.observe(document.body, { childList: true });
    var nlCarte = document.getElementById('bvf-nl');
    if (nlCarte) guet.observe(nlCarte, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('DOMContentLoaded', function () {
      var nl = document.getElementById('bvf-nl');
      if (nl && nl !== nlCarte) guet.observe(nl, { attributes: true, attributeFilter: ['class'] });
    });
  }

  var pages = (parseInt(lire(sessionStorage, CLE_PAGES), 10) || 0) + 1;
  ecrire(sessionStorage, CLE_PAGES, String(pages));

  var cartes = {};
  var liste = racine.querySelectorAll('[data-bp]');
  for (var i = 0; i < liste.length; i++) cartes[liste[i].getAttribute('data-bp')] = liste[i];

  var ouverte = null;
  var arrivee = Date.now();

  function fenetres() {
    try { var o = JSON.parse(lire(localStorage, CLE_FENETRES)); return o && typeof o === 'object' ? o : {}; } catch (e) { return {}; }
  }
  function retenirFermee(nom) {
    var o = fenetres();
    o[nom] = Date.now();
    ecrire(localStorage, CLE_FENETRES, JSON.stringify(o));
  }
  function fermeeRecemment(nom) {
    var t = parseInt(fenetres()[nom], 10) || parseInt(lire(localStorage, CLE_FERMEE + nom), 10);
    return t > 0 && Date.now() - t < QUATORZE_JOURS;
  }

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    var s = getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0';
  }

  /* Quelque chose occupe deja le visiteur : on n'ajoute rien. */
  function occupe() {
    var b = document.body, h = document.documentElement;
    if (b.classList.contains('overflow-hidden') || h.classList.contains('overflow-hidden')) return true;
    if (b.classList.contains('overflow-hidden-mobile') || b.classList.contains('overflow-hidden-tablet') || b.classList.contains('overflow-hidden-desktop')) return true;
    if (document.querySelector('cart-drawer.active, .drawer.active, details.menu-opening, .bisou-volet[aria-hidden="false"]')) return true;
    /* Le tiroir du panier garde un aria-modal en permanence, cache : seul un
       dialogue vraiment a l'ecran compte. */
    var dialogues = document.querySelectorAll('[aria-modal="true"]:not(.bp-carte)');
    for (var i = 0; i < dialogues.length; i++) if (visible(dialogues[i])) return true;
    if (visible(document.getElementById('shopify-pc__banner'))) return true;
    if (autreFenetre()) return true;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    return false;
  }

  /* Ce qui occupe deja le bas a gauche : la barre d'apercu de Shopify et la
     pastille Avant / Apres de l'ALT (apercu seulement), posee sur la barre quand
     elle est la. On empile depuis le bas de la fenetre : un obstacle compte s'il
     touche le bas ou ce qui est deja empile. La carte passe au-dessus du plus
     haut, avec 12 px d'air, quelle que soit sa marge du bas (24, 40 ou 12 px). */
  function decalageBas(carte) {
    carte.style.setProperty('--bp-decalage', '0px');
    var rc = carte.getBoundingClientRect();
    var marge = parseFloat(getComputedStyle(carte).bottom) || 0;
    var empiles = [];
    var obstacles = document.querySelectorAll('#preview-bar-iframe, #PBarNextFrameWrapper, .bvf-pastille');
    for (var i = 0; i < obstacles.length; i++) {
      var el = obstacles[i];
      if (!visible(el)) continue;
      var r = el.getBoundingClientRect();
      if (r.right < rc.left || r.left > rc.right) continue;
      empiles.push(r);
    }
    empiles.sort(function (a, b) { return b.bottom - a.bottom; });
    var haut = window.innerHeight;
    for (var j = 0; j < empiles.length; j++) {
      if (empiles[j].bottom < haut - 80) break;
      haut = Math.min(haut, empiles[j].top);
    }
    if (haut >= window.innerHeight) return 0;
    return Math.max(0, Math.round(window.innerHeight - haut + 12 - marge));
  }

  function ouvrir(nom, force) {
    var carte = cartes[nom];
    if (!carte || ouverte) return false;
    if (!force) {
      if (lire(sessionStorage, CLE_OFF) || lire(sessionStorage, CLE_VUE) || lire(sessionStorage, CLE_VISITE)) return false;
      if (fermeeRecemment(nom) || occupe()) return false;
    }
    ecrire(sessionStorage, CLE_VUE, nom);
    ecrire(sessionStorage, CLE_VISITE, nom);
    carte.hidden = false;
    carte.style.setProperty('--bp-decalage', decalageBas(carte) + 'px');
    /* Deux images : la carte se pose, puis glisse en place. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { carte.classList.add('is-ouverte'); });
    });
    ouverte = carte;
    return true;
  }

  function fermer(nom, retenir) {
    var carte = cartes[nom];
    if (!carte || carte.hidden) return;
    if (retenir) retenirFermee(nom);
    carte.classList.remove('is-ouverte');
    var fini = false;
    function cacher() { if (fini) return; fini = true; carte.hidden = true; }
    carte.addEventListener('transitionend', cacher, { once: true });
    setTimeout(cacher, 400);
    if (ouverte === carte) ouverte = null;
  }

  /* Croix et bouton d'action. En capture sur window : le coeur de la liste de
     souhaits arrete la propagation au niveau du document. */
  window.addEventListener('click', function (e) {
    var cible = e.target && e.target.closest ? e.target : null;
    if (!cible) return;
    var croix = cible.closest('[data-bp-fermer]');
    var action = cible.closest('[data-bp-action]');
    var carte = (croix || action) ? (croix || action).closest('[data-bp]') : null;
    if (!carte) return;
    var nom = carte.getAttribute('data-bp');
    if (croix) { fermer(nom, true); return; }
    /* Le coeur reste visible un instant, le temps de voir qu'il a pris. */
    if (nom === 'quitter') { setTimeout(function () { fermer(nom, true); }, 1400); return; }
    retenirFermee(nom);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ouverte) fermer(ouverte.getAttribute('data-bp'), true);
  });

  /* Un tiroir qui s'ouvre (panier, menu) passe devant : la carte s'efface.
     Le panier pose une classe sur <body> ; le menu ne change que l'aria-hidden
     de son volet. */
  if (window.MutationObserver) {
    var tiroirs = new MutationObserver(function () {
      if (ouverte && occupe()) fermer(ouverte.getAttribute('data-bp'), false);
    });
    tiroirs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var volet = document.querySelector('.bisou-volet');
    if (volet) tiroirs.observe(volet, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  /* — Quelle phase du vote ? Le lecteur partage montre un seul temoin. — */
  function phase() {
    var t = racine.querySelectorAll('[data-bisou-vote-phase]');
    for (var i = 0; i < t.length; i++) if (!t[i].hidden) return t[i].getAttribute('data-bisou-vote-phase');
    return null;
  }

  /* L'app a repondu, sans scrutin ouvert ni date arretee (le lecteur se tait
     alors) : la carte « communaute » reste juste, elle ne donne pas de date.
     La reponse est celle que le lecteur a mise en cache pour la session. */
  function appSansVoteOuvert() {
    try {
      var o = JSON.parse(sessionStorage.getItem('bisou_vote_config'));
      var v = o && o.v;
      if (!v || v.ok === false) return false;
      return !(v.campaign && v.campaign.open === true);
    } catch (e) { return false; }
  }

  function carteDuVote() {
    var p = phase();
    if (p === 'open') return 'vote';
    if (p === 'pre' || p === 'between') return 'communaute';
    if (appSansVoteOuvert()) return 'communaute';
    return null;
  }

  /* — Demande explicite (?popups=vote…) : pour regarder, tout de suite. — */
  if (demande && cartes[demande]) {
    var t = racine.querySelectorAll('[data-bisou-vote-phase]');
    for (var k = 0; k < t.length; k++) t[k].hidden = true;
    var montrer = function () { ouvrir(demande, true); };
    if (document.readyState === 'complete') setTimeout(montrer, 300);
    else window.addEventListener('load', function () { setTimeout(montrer, 300); });
    return;
  }

  if (lire(sessionStorage, CLE_OFF) || lire(sessionStorage, CLE_VUE) || lire(sessionStorage, CLE_VISITE)) return;

  /* — Le vote et la communaute : a partir de la deuxieme page de la visite,
       apres 12 s sur la page et un tiers de la page lu. — */
  if (cartes.vote || cartes.communaute) {
    var pret = false;
    document.addEventListener('bisou:vote-ready', function () { pret = true; });

    var essayer = function () {
      if (ouverte || pages < 2) return;
      if (Date.now() - arrivee < 12000) return;
      var haut = document.documentElement.scrollHeight - window.innerHeight;
      var lu = haut > 0 ? window.scrollY / haut : 1;
      if (lu < 0.33 && window.scrollY < window.innerHeight * 1.2) return;
      var nom = carteDuVote();
      if (!nom || !cartes[nom]) return;
      if (ouvrir(nom, false)) {
        window.removeEventListener('scroll', surDefilement);
        clearInterval(minuterie);
      }
    };
    var attente = null;
    var surDefilement = function () {
      if (attente) return;
      attente = setTimeout(function () { attente = null; essayer(); }, 250);
    };
    window.addEventListener('scroll', surDefilement, { passive: true });
    var minuterie = setInterval(function () {
      if (pret || phase()) essayer();
      if (Date.now() - arrivee > 10 * 60 * 1000) clearInterval(minuterie);
    }, 2000);
  }

  /* — La fiche tirage : a l'ordinateur, la souris qui part vers les onglets,
       apres 10 s sur la fiche, si rien n'a ete mis au panier. — */
  if (cartes.quitter && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var auPanier = false;
    /* Tirage deja dans la liste de souhaits : la carte proposerait de l'en
       retirer au moment du depart. On ne l'ouvre pas. */
    var dejaSouhaite = function () {
      var b = cartes.quitter.querySelector('[data-handle]');
      var h = b && b.getAttribute('data-handle');
      return !!(h && window.BisouWishlist && window.BisouWishlist.has(h));
    };
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.action && /\/cart\/add/.test(f.action)) auPanier = true;
    }, true);
    document.addEventListener('mouseout', function (e) {
      if (ouverte || auPanier || e.relatedTarget) return;
      if (e.clientY > 8) return;
      if (Date.now() - arrivee < 10000) return;
      if (dejaSouhaite()) return;
      ouvrir('quitter', false);
    });
  }
})();
